const routes = [{
  path: '/mycourse',
  load: () => import(/* webpackChunkName: 'mycourse' */ './mycourse'),
}, {
  path: '/bind',
  children: [{
    path: '/',
    load: () => import(/* webpackChunkName: 'bindsetting' */ './bind/bindSetting'),
  }, {
    path: '/(.*)bindmobile',
    load: () => import(/* webpackChunkName: 'bindmobile' */ './bind/bindMobile'),
  }],
}, {
  path: '/order',
  load: () => import(/* webpackChunkName: 'order' */ './myOrder'),
}]

export default routes



// WEBPACK FOOTER //
// ./src/routes/user/index.js